import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import Config from "@/config/config";

const app = initializeApp(Config.firebase);
const auth = getAuth(app);
const useAuthEmulator = import.meta.env.VITE_USE_AUTH_EMULATOR !== "false";

// Local dev stays on the Auth emulator by default. Set
// VITE_USE_AUTH_EMULATOR=false (web app .env) and USE_AUTH_EMULATOR=false
// (functions/.env.local) together to use real goodsender-dev Google auth on
// localhost instead. The client flag only switches the CLIENT — Functions is a
// separate process that reads its own flag, so both must be `false` or
// authenticated calls fail (real tokens vs. emulator-only verification).
if (import.meta.env.DEV && useAuthEmulator) {
  // Same host as the page. Cursor's built-in browser otherwise cannot return
  // the Firebase Auth emulator redirect result (cross-site storage).
  const emulatorHost =
    typeof window !== "undefined" && window.location.hostname === "localhost"
      ? "localhost"
      : "127.0.0.1";
  const emulatorUrl = (import.meta.env.VITE_AUTH_EMULATOR_URL as string | undefined) || `http://${emulatorHost}:9099`;
  connectAuthEmulator(auth, emulatorUrl, { disableWarnings: true });
}

export { auth };
